import React, { useState } from "react";
import axiosInsatnace, {
  chatStatus,
  contactView,
  getProfileById,
} from "../../../asiosConfig";

import {
  getMatchesByTypeJava,
  contactViewJava,
  profileActivityJava,
} from "../../../javaAxiosConfig";

import Popup from "../../Popup";

import sendInterestIcons from "../../../images/sendInterestIcon.png";
import chatWhiteIcon from "../../../images/chatWhiteIcon.png";
import diclineWhiteIcon from "../../../images/diclineWhiteIcon.png";
import callWhiteIcon from "../../../images/callWhiteIcon.png";
import acceptIcon from "../../../images/acceptIcon.png";
import popup from "../../../images/popup_design.png";
import TimeDateIcon from "../../../images/TimeDateIcon.png";
import shortlistIcon from "../../../images/shortlistIcon.png";
import SendInterest from "../../../images/sendIntrestFull.svg";
import IgnoreIcon from "../../../images/ignorecross.png";
// import ContactIcon from "../../../images/ContactIcon.png";

import ContactIcon from "../../../images/contact-icon.svg";
import AcceptInterestIcon from "../../../images/acceptIcon.svg";
import BookMarkRemoveIcon from "../../../images/BookmarkIcon.png";
import DeclinedInterestIcon from "../../../images/declineIcon.svg";
import sendRemidIcon from "../../../images/sendReminder.png";
import ChatIcon from "../../../images/messageNow.svg";
import RemoveIgnoreIcon from "../../../images/RemoveIgnoreIcon.png";

import { IoMdUndo } from "react-icons/io";

import { useNavigate } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../../services/firebaseConfig";
import MessengerModal from "../../MessengerModel";

const isEmpty = (array) => Array.isArray(array) && array.length === 0;

// const getProfileActionType = (profile) => {
//   if (!profile) return "DEFAULT";

//   if (profile.ignored === true) {
//     return "IGNORED";
//   }

//   if (profile.interest_i_accept === true) {
//     return "INTEREST_ACCEPTED";
//   }

//   if (profile.interest_received === true) {
//     return "INTEREST_RECEIVED";
//   }

//   if (profile.interest_sent === true) {
//     return "INTEREST_SENT";
//   }

//   return "DEFAULT";
// };

const getProfileActionType = (profile) => {
  if (!profile) return "DEFAULT";


    if (profile.ignored === true && profile.interest_sent === true) {
    return "IGNORED_INTEREST_SENT";
  }

  // Ignore overrides everything
  if (profile.ignored === true) {
    return "IGNORED";
  }

  // Interest accepted
  if (profile.interest_i_accept === true) {
    return "INTEREST_ACCEPTED";
  }

  // Interest received
  if (profile.interest_received === true) {
    return "INTEREST_RECEIVED";
  }

  // Interest accepted
  if (profile.interest_i_accept === true) {
    return "INTEREST_ACCEPTED";
  }

  // Interest sent
  if (profile.interest_sent === true) {
    return "INTEREST_SENT";
  }

  return "DEFAULT";
};

const ACTION_CONFIG = {
  DEFAULT: [
    { key: "IGNORE", label: "Ignore", icon: IgnoreIcon },
    { key: "SEND_INTEREST", label: "Send Interest", icon: SendInterest },
    { key: "CHAT", label: "Message Now", icon: ChatIcon },
    // { key: "CONTACT", label: "Contact", icon: ContactIcon },
  ],

  INTEREST_SENT: [
    { key: "IGNORE", label: "Ignore", icon: IgnoreIcon },
    { key: "SEND_REMINDER", label: "Send Reminder", icon: sendRemidIcon },
    { key: "CHAT", label: "Message Now", icon: ChatIcon },
    // { key: "CONTACT", label: "Contact", icon: ContactIcon },
  ],

  INTEREST_RECEIVED: [
    { key: "ACCEPT", label: "Accept", icon: AcceptInterestIcon },
    { key: "DECLINE", label: "Decline", icon: DeclinedInterestIcon },
    // { key: "CONTACT", label: "Contact", icon: ContactIcon },
  ],

  INTEREST_ACCEPTED: [
    { key: "IGNORE", label: "Ignore", icon: IgnoreIcon },
    { key: "CHAT", label: "Message Now", icon: ChatIcon },
    // { key: "CONTACT", label: "Contact", icon: ContactIcon },
  ],

  IGNORED: [
    { key: "REMOVE_IGNORE", label: "Remove Ignore", icon: IoMdUndo },
    { key: "SEND_INTEREST", label: "Send Interest", icon: SendInterest },
    // { key: "SEND_REMINDER", label: "Send Reminder", icon: sendRemidIcon },
    { key: "CHAT", label: "Message Now", icon: ChatIcon },
    // { key: "CONTACT", label: "Contact", icon: ContactIcon },
  ],

  IGNORED_INTEREST_SENT: [
  { key: "REMOVE_IGNORE", label: "Remove Ignore", icon: IoMdUndo },
  { key: "SEND_REMINDER", label: "Send Reminder", icon: sendRemidIcon },
  { key: "CHAT", label: "Message Now", icon: ChatIcon },
],
};

export const ActionButton = ({ profileData, onContactResult }) => {
  const {
    send = [],
    received = [],
    ignored = [],
    bookmarked = [],
    user_info,
  } = profileData?.search || {};
  const recipientId = user_info?.register_id;
  const [contactInfo, setContactInfo] = useState(null);








  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  React.useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);








  const [loading, setLoading] = useState(null);
  // const [updatedData, setUpdatedData] = useState(profileData);

  const [updatedData, setUpdatedData] = useState(() => {
    if (!profileData) return profileData;

    return {
      ...profileData,
      search: {
        ...profileData.search,
        // inject safely if exists at root level
        interest_i_accept:
          profileData?.interest_i_accept ??
          profileData?.data?.interest_i_accept ??
          profileData?.search?.interest_i_accept ??
          false,
      },
    };
  });

  const navigate = useNavigate();
  const username = localStorage.getItem("username");
  const [openMessengerModal, setOpenMessengerModal] = useState(false);

  const [popupState, setPopupState] = useState({
    open: false,
    type: "success",
    title: "",
    message: "",
  });

  const applyLocalActionUpdate = (actionKey) => {
    setUpdatedData((prev) => {
      if (!prev?.search) return prev;

      const next = { ...prev.search };

      switch (actionKey) {
        case "SEND_INTEREST":
          next.interest_sent = true;
          next.interestSent = true;
          break;

        case "ACCEPT":
          next.interest_i_accept = true;
          next.interestAccepted = true;
          next.interest_received = false;
          next.interestReceived = false;
          break;

        case "DECLINE":
          next.interest_received = false;
          next.interestReceived = false;
          break;

        case "IGNORE":
          next.ignored = true;
          next.isIgnored = true;
          break;

        case "REMOVE_IGNORE":
          next.ignored = false;
          next.isIgnored = false;
          break;

        default:
          break;
      }

      return { ...prev, search: next };
    });
  };

  const showPopup = (type, message) => {
    setPopupState({
      open: true,
      type,
      title: type === "success" ? "Success" : "Error",
      message,
    });
  };

  // new handler for action buttons that gets the button state and tell what buttons to show

  const handleActionByKey = (actionKey) => {
    switch (actionKey) {
      case "SEND_INTEREST":
        return handleAction(
          "profile-activity",
          { user_id: recipientId, response_type: "interest" },
          "SEND_INTEREST",
        );

      case "SEND_REMINDER":
        return handleReminder(
          "profile-activity",
          { user_id: recipientId, response_type: "send_reminder" },
          "SEND_REMINDER",
        );

      case "ACCEPT":
        return handleAction(
          "profile-activity",
          { user_id: recipientId, response_type: "accept" },
          "ACCEPT",
        );

      case "DECLINE":
        return handleAction(
          "profile-activity",
          { user_id: recipientId, response_type: "reject" },
          "DECLINE",
        );

      case "IGNORE":
        return handleAction(
          "profile-activity",
          { user_id: recipientId, response_type: "ignored" },
          "IGNORE",
        );

      case "REMOVE_IGNORE":
        return handleAction(
          "profile-activity",
          { user_id: recipientId, response_type: "remove_ignore" },
          "REMOVE_IGNORE",
        );

      case "CHAT":
        return startChat(user_info.username, user_info);

      case "CONTACT":
        return handleContactClick();

      default:
        return null;
    }
  };

  const handleAction = async (_, data, actionKey) => {
    setLoading(actionKey);
    try {
      const response = await profileActivityJava(data);

      if (response?.data?.status === true) {
        showPopup("success", response.data.message);

        // ✅ instant UI update (like Match)
        applyLocalActionUpdate(actionKey);
      } else {
        showPopup("error", response?.data?.message || "Action failed");
      }
    } catch (error) {
      showPopup("error", "Something went wrong");
    } finally {
      setLoading(null);
    }
  };

  const handleReminder = async (_, data, actionKey) => {
    setLoading(actionKey);
    try {
      const response = await profileActivityJava(data);

      if (response?.data?.status === true) {
        showPopup("success", response.data.message);

        // ✅ DO NOT refetch
        // Reminder does not change interest state,
        // so no button transition needed
      } else {
        showPopup("error", response?.data?.message);
      }
    } catch (error) {
      showPopup("error", "Something went wrong");
    } finally {
      setLoading(null);
    }
  };

  const handleContactClick = async () => {
    if (!recipientId) {
      showPopup("error", "Profile id missing. Unable to fetch contact.");
      return;
    }

    setLoading("Contact");
    try {
      // const response = await contactViewJava({ profile_id: recipientId });
      const response = await contactViewJava({ toUserId: recipientId });

      if (response.status === 200 || response.status === 201) {
        logEvent(analytics, "view_contact", {
          user_id: localStorage.getItem("user"),
          profile_id: recipientId,
          action: "contact_view",
          platform: "web",
          timestamp: new Date().toISOString(),
        });
        // setContactInfo(response.data.data);
        setContactInfo({
          phone: response.data.message,
        });

        onContactResult({
          type: "success",
          phone: response.data.message,
          message: null,
          username: user_info?.username,
          photo: user_info?.photo,
        });
      } else {
        // toast.error(response.data.message);
        // showPopup("error", response.data.message);
        onContactResult({
          type: "error",
          phone: null,
          message: response.data.message,
          username: user_info?.username,
          photo: user_info?.photo,
        });
      }
    } catch (error) {
      // showPopup(
      //   "error",
      //   error.response?.data?.message || "Failed to retrieve contact info"
      // );

      onContactResult({
        type: "error",
        phone: null,
        message:
          error.response?.data?.message || "Failed to retrieve contact info",
        username: user_info?.username,
        photo: user_info?.photo,
      });
    } finally {
      setLoading(null);
    }
  };

  const startChat = async (recipientId, profile) => {
    // const currentUserId = username;
    // const chatId = [currentUserId, recipientId].sort().join('_');
    // try {
    //     const response = await chatStatus({profile_id: profile.register_id });

    //     const { SUCCESS, ERROR, chatReason, chatAllowed } = response.data;
    //     if (SUCCESS === 1 && chatAllowed === "true") {
    //         navigate(`/chat`, { state: { chatId, recipientId, profile } });

    //     } else {
    //         toast.error(ERROR || chatReason);
    //     }
    // } catch (error) {
    //     toast.error("Error starting chat:", error);
    // }
    setOpenMessengerModal(true);
  };



  const isMidScreen = screenWidth <= 1024 && screenWidth >= 768;
  const isMobile = screenWidth < 768;


  const renderButtons = () => {
    const actionType = getProfileActionType(updatedData?.search);
    const actions = ACTION_CONFIG[actionType] || [];

    return (
      <div
        className="action-container"
        style={
          isMidScreen
            ? {
              width: "100%",
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "12px",
              justifyItems: "center",
            }
            : isMobile
              ? {
                width: "100%",
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)", // 🔥 2 per row
                gap: "10px",
                justifyItems: "center",
              }
              : {
                width: "100%",
                display: "flex",
                gap: "12px",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
              }
        }
      >
        {actions.map(({ key, label, icon }, index) => {
          const isIgnore = label === "Ignore" || label === "Remove Ignore";
          const isPrimaryOutline =
            label === "Send Interest" || label === "Send Reminder";
          const isMessage = label === "Message Now";

          const isLastOddMobile =
            isMobile &&
            actions.length % 2 !== 0 &&
            index === actions.length - 1;

          return (
            <div
              key={key}
              style={{
                width: isMobile ? "100%" : "auto",
                flex: !isMobile && !isMidScreen ? 1 : "auto", // Allow buttons to share space on desktop
                minWidth: !isMobile ? "140px" : "auto",
                maxWidth: isMobile ? "100%" : isMidScreen ? "100%" : "250px",

                // 🔥 CENTER last single button on mobile
                gridColumn: isLastOddMobile ? "1 / span 2" : "auto",

                padding: isPrimaryOutline ? "1px" : "0",
                borderRadius: "30px",
                background: isPrimaryOutline
                  ? "linear-gradient(90deg,#FF9F43,#FF3C3C)"
                  : "transparent",
                transition: "transform 0.2s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-2px)")}
              onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
            >
              <div
                onClick={() => handleActionByKey(key)}
                style={{
                  width: "100%",
                  padding: isMobile ? "8px 10px" : "10px 20px",
                  borderRadius: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: isMobile ? "6px" : "10px",
                  cursor: "pointer",
                  fontWeight: 600,

                  fontSize: isMobile ? "12.5px" : "13.5px",

                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",

                  background: isMessage ? "linear-gradient(135deg, #FF6F00 0%, #FF8F00 100%)" : "#FFFFFF",

                  border: !isPrimaryOutline
                    ? isIgnore
                      ? "1px solid #D6D6D6"
                      : "1px solid #E6EEF6"
                    : "none",

                  color: isMessage
                    ? "#FFFFFF"
                    : isIgnore
                      ? "#333"
                      : "#333",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                }}
              >
                <span>{label}</span>

                {typeof icon === "string" ? (
                  <img
                    src={icon}
                    width={isMobile ? "14" : "16"}
                    style={{ filter: isMessage ? "brightness(0) invert(1)" : "none" }}
                    alt=""
                  />
                ) : (
                  (() => {
                    const IconComponent = icon;
                    return <IconComponent size={isMobile ? 14 : 16} />;
                  })()
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  };





  return (
    <>
      {renderButtons()}

      <MessengerModal
        open={openMessengerModal}
        onClose={() => setOpenMessengerModal(false)}
      />

      <Popup
        open={popupState.open}
        type={popupState.type}
        title={popupState.title}
        message={popupState.message}
        onClose={() => setPopupState((prev) => ({ ...prev, open: false }))}
      />
    </>
  );
};
